import { ElementType, ReactNode } from 'react';

import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import { BenefitsDividerSVG } from '../../../../../../svgComponents/benefitsDividerSVG/BenefitsDividerSVG';
import { OverpayLoanSVG } from '../../../../../../svgComponents/overpayLoanSVG/OverpayLoanSVG';
import { TopupSVG } from '../../../../../../svgComponents/topupSVG/TopupSVG';
import { WithdrawFundsSVG } from '../../../../../../svgComponents/withdrawFundsSVG/WithdrawFundsSVG';

const Benefit = ({
    IconComponent,
    children
}: {
    IconComponent: ElementType;
    children: ReactNode;
}) => (
    <div className="flex grow flex-col gap-s min-sm:flex-row min-sm:items-center">
        <IconComponent className="shrink-0" />
        <Text className="text-xs min-sm:text-s">{children}</Text>
    </div>
);

export const BenefitsList = () => (
    <div className="border-b border-secondary-90 px-l pb-l pt-l min-sm:px-xl">
        <Text className="text-m font-med">
            <FormattedMessage
                id="_.benefits_list.title"
                defaultMessage="How most customers use our loans"
            />
        </Text>

        <div className="mt-m flex items-center gap-m">
            <Benefit IconComponent={WithdrawFundsSVG}>
                <FormattedMessage
                    id="_.benefits_list.withdraw"
                    defaultMessage="Withdraw funds as needed"
                />
            </Benefit>

            <BenefitsDividerSVG className="shrink-0" />

            <Benefit IconComponent={OverpayLoanSVG}>
                <FormattedMessage
                    id="_.benefits_list.overpay"
                    defaultMessage="Overpay or settle early with no extra fees"
                />
            </Benefit>

            <BenefitsDividerSVG className="shrink-0" />

            <Benefit IconComponent={TopupSVG}>
                <FormattedMessage
                    id="_.benefits_list.topup"
                    defaultMessage="Top up for more funds"
                />
            </Benefit>
        </div>
    </div>
);
